<template>
  <div class="AppForecast">
    <!-- {{ buttonClicked }} -->
    <div class="tab mt-2">
      <div class="flex items-end">
        <div class="input-box box-220">
          <p class="input-label">Period</p>
          <!-- <el-select v-model="period" @change="periodChange"> -->
          <el-select v-model="period">
            <el-option value="day" label="1 Day"> 1 Day </el-option>
            <el-option value="1 week" label="1 Week"> 1 Week </el-option>
            <el-option value="2 week" label="2 Weeks"> 2 Weeks </el-option>
            <el-option value="4 week" label="4 Weeks"> 4 Weeks </el-option>
            <el-option value="8 week" label="8 Weeks"> 8 Weeks </el-option>
            <el-option
              v-if="isCategoryPage || isCentralKitchenPage"
              value="12 week"
              label="12 Weeks"
            >
              12 Weeks
            </el-option>
            <!-- <el-option v-if="isCategoryPage" value="52 week" label="52 Weeks">
            52 Weeks
          </el-option> -->
            <el-option value="custom" label="Custom Dates"> Custom Dates</el-option>
          </el-select>
        </div>
        <div class="input-box box-220">
          <p class="input-label">From Date</p>
          <el-date-picker
            v-model="fromDate"
            v-validate="'required'"
            style="width: 100%"
            type="date"
            placeholder="From Date"
            name="from date"
            :picker-options="date_range_options"
            :disabled="disableAllDate"
            @change="fromDate ? '' : (toDate = '')"
          ></el-date-picker>
        </div>
        <div class="input-box box-220">
          <p class="input-label">To Date</p>
          <el-date-picker
            v-model="toDate"
            v-validate="'required'"
            style="width: 100%"
            type="date"
            placeholder="To Date"
            name="to date"
            :picker-options="date_range_options"
            :disabled="disableAllDate"
          ></el-date-picker>
        </div>
        <div class="input-box box-300">
          <p class="input-label">Location</p>
          <base-locations-dropdown :show-label="false" @selectedLocationVal="dropDownUpdate" />
        </div>
        <div
          v-if="
            $route.name == 'forecastCategory' ||
            $route.name == 'forecastCentralKitchen'
          "
          class="input-box box-220"
        >
          <p class="input-label">Type</p>
          <!-- <el-select v-model="type" @change="periodChange"> -->
          <el-select v-model="type">
            <el-option value="product" label="Product"> Product </el-option>
            <el-option value="r_material" label="Raw Material">
              Raw Material
            </el-option>
            <el-option value="intermediate" label="Intermediate">
              Intermediate
            </el-option>
          </el-select>
        </div>
        <div>
          <el-button class="el-button el-button--warning" :disabled="formValid" @click="generateSalesForecast">Go</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" top="0">
      <app-detailed-forecast
        :key="componentKey"
        :query-detail-response="queryDetailResponse"
        :disabled-allow="approveDisable"
      />
    </el-dialog>
  </div>
</template>

<script>
import BaseLocationsDropdown from "../../baseLocationsDD/BaseLocationsDD.vue";
import AppDetailedForecast from "../appDetailedForcast/AppDetailedForcast.vue";
import { mapActions, mapState } from "vuex";
import ForecastService from "../../../services/forecastService";
import { AppForecastTabNC } from "../../../../mixins/appForecastTabNC";
import { CommonMixin } from "../../../../mixins/common.mixin";
import axios from "axios";
import { EventBus } from "../../../eventBus";
// import { mapGetters } from "vuex";
// import { Breadcrumb } from "element-ui";
import forecastService from "../../../services/forecastService";
import CommonService from "../../../services/commonService";
import moment from "moment";
import CommonUtils from "../../../utils/common.utils";
const locationBasicsTypes = ["country", "region", "subregion", "outlet"];
export default {
  name: "AppForecast",
  components: {
    BaseLocationsDropdown,
    AppDetailedForecast,
  },
  mixins: [AppForecastTabNC, CommonMixin],
  props: {},
  data() {
    return {
      componentKey: 0,
      days: 7,
      period: "1 week",
      type: "product",
      aggregate: "week",
      location: "Locations All",
      basics: "",
      loc_selected: [],
      cat_selected: [],
      isBasicsFromTableClick: false,
      start_date: this.currentDate(),
      isConsolidated: null,
      include_start_day: false,
      // buttonClicked: {},
      periodMapping: {
        day: 1,
        "1 week": 1,
        "2 week": 2,
        "4 week": 4,
        "8 week": 8,
        "12 week": 12,
        "52 week": 52,
        "7 days": 7,
      },
      dialogVisible: false,
      queryDetailResponse: {},
      isCategoryPage: this.$route.name == "forecastCategory" ? true : false,
      isCentralKitchenPage:
        this.$route.name == "forecastCentralKitchen" ? true : false,
      isLocationPage: this.$route.name == "forecastLocation" ? true : false,
      whenInCatBasics: "",

      pageInfo: {
        currentPage: 1,
        pageSize: 10,
      },
      locBasicsInCatPage: "",
      basicsInfo: {
        id: "",
        route: this.$route.name,
        basicsFrom: "",
        previousBasics: "",
        currentBasics:
          this.$route.name == "forecastLocation" ? "region" : "category",
        // this.$route.name != "forecastCategory" ? "region" : "category"
      },
      stored_breadCrumbs: [],
      outlets: {},
      approveDisable: false,
      date_range_options: {
        firstDayOfWeek: 1,
        disabledDate: Date.now() - 8.64e7
      },
      updatedLocations: [],
    };
  },
  computed: {
    ...mapState("CommonStore", ["locations", "categories"]),
    ...mapState("AppForecastStore", [
      "forecastAnalytics",
      "basicsStore",
      "num_periodStore",
      "periodStore",
      "queryObjectDate",
      "aggregateStore",
      "forecastFromDate",
      "forecastToDate",
      "forecastChartData",
      "forecastTableLoader",
      "forecastGraphLoader"
    ]),
    // updatedFilters() {
    // 	return this.filters.filter(object => object.id);
    // },
    getAggreate() {
      return this.period == "1 week" ||
        this.period == "2 week" ||
        this.period == "4 week" ||
        this.period == "8 week" ||
        this.period == "12 week" ||
        this.period == "52 week"
        ? "week"
        : "day";
    },
    filterLocIds() {
      if(this.loc_selected && this.loc_selected.length && Array.isArray(this.loc_selected)) {
        // const locSelected = this.$store.getters.getLocSelected;
        return this.loc_selected.filter(el => el.id).map((obj) => obj.id);
      } else {
        return [];
      }
    },

    filterCatIds() {
      return this.cat_selected.map((obj) => obj.id);
    },
    fromDate: {
      get() {
        return this.forecastFromDate;
      },
      set(value) {
        this.$store.commit("AppForecastStore/UPDATE_FROM_DATE", value);
      }
    },
    toDate: {
      get() {
        return this.forecastToDate;
      },
      set(value) {
        this.$store.commit("AppForecastStore/UPDATE_TO_DATE", value);
      }
    },
    disableAllDate() {
      if(this.period == "custom") {
        return false;
      } else {
        return true;
      }
    },
    forecastChartListData: {
      get() {
        let data = JSON.parse(this.forecastChartData);
        return data;
      },
      set(value) {
        this.$store.commit("AppForecastStore/UPDATE_FORECAST_DATA", value);
      }
    },
    formValid() {
      if(this.fromDate && this.toDate) {
        let fromDate = moment(this.fromDate).isValid();
        let toDate = moment(this.toDate).isValid();
        if(fromDate && toDate) {
          return false;
        } else {
          return true;
        }
      } else {
         return true;
      }
    },
    loaderTable: {
      get() {
        return this.forecastTableLoader;
      },
      set(value) {
        this.$store.commit("AppForecastStore/UPDATE_FORECAST_TABLE_LOADER", value);
      }
    },
    graphLoader: {
      get() {
        return this.forecastGraphLoader;
      },
      set(value) {
        this.$store.commit("AppForecastStore/UPDATE_FORECAST_GRAPH_LOADER", value);
      }
    },
    newLocationsData() {
      function capitalizeLabel(label) {
        return label[0].toUpperCase() + label.slice(1).toLowerCase();
      }
      const data = this.updatedLocations;
      // CHange key of data array regions to children
      data.map(item => {
        item.children = item.regions
        item.label = item.name.toLowerCase();
        item.value = item.id

        item.children.map(child => {
          child.children = child.subregions
          child.label = child.name.toLowerCase();
          child.value = child.id

          child.children.map(sub_child => {
            sub_child.children = sub_child.outlets
            sub_child.label = sub_child.name.toLowerCase();
            sub_child.value = sub_child.id

            sub_child.children.map(sub_child_two => {
              sub_child_two.label = sub_child_two.name.toLowerCase();
              sub_child_two.value = sub_child_two.id
            })

          })

        })
      }
      )

      return data;
    }
  },
  watch: {
    period(newValue, oldValue) {
      let date = new Date();
      if(newValue == "day") {
        this.fromDate = moment(date).format("YYYY-MM-DD");
        this.toDate = moment(date).add("d", 1).format("YYYY-MM-DD");
        this.days = 1;
      } else if(newValue == "1 week") {
        this.fromDate = moment(date).format("YYYY-MM-DD");
        this.toDate = moment(date).add("d", 7).format("YYYY-MM-DD");
        this.days = 7;
      } else if(newValue == "2 week") {
        this.fromDate = moment(date).format("YYYY-MM-DD");
        this.toDate = moment(date).add("d", 14).format("YYYY-MM-DD");
        this.days = 14;
      } else if(newValue == "4 week") {
        this.fromDate = moment(date).format("YYYY-MM-DD");
        this.toDate = moment(date).add("d", 28).format("YYYY-MM-DD");
        this.days = 28;
      } else if(newValue == "8 week") {
        this.fromDate = moment(date).format("YYYY-MM-DD");
        this.toDate = moment(date).add("d", 56).format("YYYY-MM-DD");
        this.days = 56;
      } else if(newValue == "12 week") {
        this.fromDate = moment(date).format("YYYY-MM-DD");
        this.toDate = moment(date).add("d", 84).format("YYYY-MM-DD");
        this.days = 84;
      } else if(newValue == "custom") {
        if(this.fromDate && this.toDate) {
          let fromDate = moment(this.fromDate);
          let toDate = moment(this.toDate);
          this.days = toDate.diff(fromDate, "days");
        }
      }
    },
    fromDate(newValue, oldValue) {
      if(this.fromDate && this.toDate) {
        let fromDate = moment(this.fromDate);
        let toDate = moment(this.toDate);
        this.days = toDate.diff(fromDate, "days");
      }
    },
    toDate(newValue, oldValue) {
      if(this.fromDate && this.toDate) {
        let fromDate = moment(this.fromDate);
        let toDate = moment(this.toDate);
        this.days = toDate.diff(fromDate, "days");
      }
    },
  },
  created() {
    // if (this.$route.name == "forecastCategory") {
    // 	this.getLocations({
    // 		type: [
    // 			"store",
    // 			"warehouse",
    // 			"head_office",
    // 			"distribution_centre",
    // 			"regional_office",
    // 			"vendor"
    // 		]
    // 	});
    // } else if (this.$route.name == "forecastCentralKitchen") {
    // 	this.getLocations({ type: ["central_kitchen"] });
    // } else {
    // 	this.getLocations();
    // }
    if (this.isCategoryPage || this.isCentralKitchenPage) {
      this.getCategories();
    }
    // if (this.isCategoryPage) {
    // 	this.initalCategoryData();
    // } else {
    // 	this.initalData();
    // }
  },
  updated() {
    // if (this.isCategoryPage) {
    // 	this.initalCategoryData();
    // } else {
    // 	this.initalData();
    // }
  },
  mounted() {
    EventBus.$on("buttonClickedEvent", this.buttonClickedFn);
    EventBus.$on("clickBreadcurmbForecastEvent", this.breadcrumbClickableFn);
    EventBus.$on("clickToShowInitialForecastData", this.showInitialData);
    EventBus.$on("pageInfoChangeForecastEvent", this.handlePageInfoChange);
    EventBus.$on("downloadCsvEvent", this.getOptionsSelected);
    EventBus.$on("closeDialogBoxEvent", this.closeDialogBox);
    if (this.$route.name === "forecastCentralKitchen") {
      // this.loadCentralKitchenDashboard({
      // 	fields: ["id"],
      // 	type: ["central_kitchen"],
      // 	get_all: true
      // });
      this.basicsInfo.currentBasics = "category";
      // console.log("this.basicsInfo", this.basicsInfo);
      this.setWeekIncludeStartDay();
      this.inputChanged(this.queryObject(this.basicsInfo), this.pageInfo);
    } else {
      if (this.isCategoryPage || this.isCentralKitchenPage) {
        this.setWeekIncludeStartDay();
      }
      this.inputChanged(this.queryObject(this.basicsInfo), this.pageInfo);
    }
    EventBus.$on("breadCrumbs", (data) => {
      this.stored_breadCrumbs = data;
    });
    // EventBus.$on(
    // 	"currentPageChangeForecastEvent",
    // 	this.handleCurrentPageChange
    // );
    let date = new Date();
    this.fromDate = moment(date).format("YYYY-MM-DD");
    this.toDate = moment(date).add("d", 7).format("YYYY-MM-DD");
    this.generateSalesForecast();
    this.getLocations();
  },
  beforeDestroy() {
    EventBus.$off("downloadCsvEvent", this.getOptionsSelected);
    EventBus.$off("buttonClickedEvent", this.buttonClickedFn);
    EventBus.$off("clickBreadcurmbForecastEvent", this.breadcrumbClickableFn);
    EventBus.$off("clickToShowInitialForecastData", this.showInitialData);
    EventBus.$off("pageInfoChangeForecastEvent", this.handlePageInfoChange);
  },
  methods: {
    ...mapActions("CommonStore", ["getLocations", "getCategories"]),
    ...mapActions("AppForecastStore", ["fetchForecast"]),
    handlePageInfoChange(pageSize) {
      this.pageInfo.pageSize = pageSize.pageSize;
      this.pageInfo.currentPage = pageSize.currentPage;
      // console.log("handlePageSizeChange", pageSize);
      this.inputChanged(this.queryObject(this.basicsInfo), this.pageInfo);
    },
    // initalData() {
    // 	// this.$store.commit("AppForecastStore/BASICS_STORE", "region");
    // 	// this.$store.commit(
    // 	// 	"AppForecastStore/NUM_PERIOD_STORE",
    // 	// 	this.periodMapping[this.period]
    // 	// );
    // 	// this.$store.commit("AppForecastStore/AGGREGATE_STORE", this.getAggreate);
    // 	this.resetPageInfo();
    // 	this.inputChanged(this.queryObject, this.pageInfo);
    // },
    // initalCategoryData() {
    // 	// this.basics = "category";
    // 	// this.$store.commit("AppForecastStore/BASICS_STORE", "category");
    // 	// this.loc_selected = [];
    // 	// this.period = "1 week";
    // 	// this.$store.commit(
    // 	// 	"AppForecastStore/NUM_PERIOD_STORE",
    // 	// 	this.periodMapping[this.period]
    // 	// );
    // 	// this.$store.commit("AppForecastStore/AGGREGATE_STORE", this.getAggreate);
    // 	this.resetPageInfo();
    // 	this.inputChanged(this.queryObject(), this.pageInfo);
    // },
    queryObject(result) {
      // console.log("result", result);
      this.basics = result.currentBasics;
      let obj = {
        // start_date: this.start_date,
        // num_period: this.periodMapping[this.period],
        include_start_day: this.include_start_day,
        view: "amt",
        // aggregate: this.getAggreate,
        basics: this.basics,
        filters: this.getAllFilters(false, result),
        extra_keys: this.$route.name == "forecastLocation" ? "trans" : "qty",
      };
      
      if(typeof(this.loc_selected[0]) === 'object'){
        obj.filters.outlets = [this.loc_selected[0].id];
        obj.filters.categories = [];
        obj.filters.subcategories = [];
        obj.filters.departments = [];
        obj.filters.products = [];
      } else {
        obj.filters.outlets = this.loc_selected.length ? this.loc_selected : [];
      }
      if(this.period == "custom") {
        obj.aggregate = "day";
        obj.start_date = moment(this.fromDate).format("YYYY-MM-DD");
        obj.num_period = moment.duration(moment(this.toDate).diff(moment(this.fromDate))).asDays();
      } else {
        obj.num_period = this.periodMapping[this.period];
        obj.aggregate = this.getAggreate;
        obj.start_date = this.start_date;
      }
      this.$route.name == "forecastCentralKitchen"
        ? (obj.outlet_type = "central_kitchen")
        : "";
      this.$route.name == "forecastCategory" ||
      this.$route.name == "forecastCentralKitchen"
        ? (obj.type = this.type)
        : "";
      return obj;
    },
    dropDownUpdate(update) {
      console.log("update", update);
      // this.loc_selected = update.selected;
      this.loc_selected = update;
      this.selected_outlets = update;
      // if (this.buttonClicked.isDateClick) {
      // 	this.period = "1 week";
      // }
      if (
        this.isCategoryPage ||
        (this.isCentralKitchenPage &&
          // locationBasicsTypes.indexOf(update.basics) > -1)
          locationBasicsTypes.indexOf("outlet") > -1)
      ) {
        // this.locBasicsInCatPage = update.basics;
        this.locBasicsInCatPage = "outlet";
      } else {
        // this.basicsInfo = this.getBasics(update.basics, update.id, "dropdown");
        this.basicsInfo = this.getBasics("outlet", update[update.length - 1], "dropdown");
      }
      console.log("update this.basicsInfo", this.basicsInfo);

      this.start_date = this.currentDate();
      this.resetPageInfo();
      // this.inputChanged(this.queryObject(this.basicsInfo), this.pageInfo);
    },
    buttonClickedFn(element) {
      // console.log("this.start_date", this.start_date, this.basics);
      // console.log("Line 492 AppForecastTab.vue", element);
      if(element.basics) {
        this.basics = element.basics;
      }
      if (this.basics == "outlet") {
        // used in utils file
        // this.$store.commit("AppForecastStore/OUTLET", element);
        this.$store.commit("AppForecastStore/OUTLET", element.id);
      }
      if (this.basics == "product") {
        // used in utils file
        // this.$store.commit("AppForecastStore/PRODUCT", element);
        this.$store.commit("AppForecastStore/PRODUCT", element.id);
      }

      // this.buttonClicked = Object.assign({}, this.buttonClicked, element);
      if (element.isApproveClicked) {
        this.handleforecastDetailQuery(element);
      } else {
        this.handleButtonClick(element, element.basics);
        // console.log(" handleButtonClick ");
      }
    },
    handleButtonClick(element, selected_basics) {
      if (this.isLocationPage) {
        this.loc_selected = [element];
      }
      if(selected_basics) {
        this.basics = selected_basics;
      }
      if (this.isCategoryPage) {
        this.cat_selected = [element];
        this.resetPageInfo();
      }
      if (this.isCentralKitchenPage) {
        this.cat_selected = [element];
        this.resetPageInfo();
      }
      // this.start_date = this.currentDate();
      if (element.isWeekClick) {
        // console.log(" handleButtonClick ", this.start_date, element);
        // this.$store.commit("AppForecastStore/NUM_PERIOD_STORE", 7);
        this.period = "7 days";
        this.start_date = element.value;
        this.include_start_day = true;
        this.aggregate = "day";
        // this.$store.commit("AppForecastStore/AGGREGATE_STORE", "day");
      }
      if (this.basics == "outlet" && this.aggregate == "week") {
        // set weeks start date & include_start_day as true, when basics is outlet & aggregate is week
        this.setWeekIncludeStartDay();
      }

      // if (
      // 	this.period != "day" &&
      // 	(this.isCategoryPage || this.$router.name == "forecastCentralKitchen")
      // ) {
      // 	this.setWeekIncludeStartDay();
      // }
      EventBus.$emit("activeBreadCrumb", element.value);

      this.basicsInfo = this.getBasics(element.basics, element.id, "table");
      const queryObject = this.queryObject(this.basicsInfo);

      var temp = [];
      temp.push(element);
      temp.push(this.basicsInfo);
      temp.push(queryObject);

      var regex = /^\d{4}-\d{2}-\d{2}$/;
      if (this.stored_breadCrumbs.length) {
        if (this.lookup(element.value, this.stored_breadCrumbs)) {
          //found current breadcurb is alrady exit in store bradcurmb
          // console.log("loopkup true", this.lookup(element.value));
          for (var i in this.stored_breadCrumbs) {
            for (var key in this.stored_breadCrumbs[i]) {
              if (key === element.value) {
                this.stored_breadCrumbs.splice(
                  Number(i),
                  this.stored_breadCrumbs.length - 1
                ); // removed exit breadcurmb & add new selected bd
                this.stored_breadCrumbs.push({
                  [element.value]: temp,
                });
              }
            }
          }
        } else {
          // current breadrumb is not found in store bd's
          for (var key in this.stored_breadCrumbs[
            this.stored_breadCrumbs.length - 1
          ]) {
            if (!regex.test(key)) {
              // console.log("regex false", regex.test(key));
              // checking last breadcurmb is not in date format & its will store
              this.stored_breadCrumbs.push({
                [element.value]: temp,
              });
            } else {
              // console.log("regex true", regex.test(key));
              // found last breadcurmb is in date format then removed it & added new bd
              this.stored_breadCrumbs.splice(-1, 1);
              this.stored_breadCrumbs.push({
                [element.value]: temp,
              });
            }
          }
        }
      } else {
        // console.log("if not length"); //found breadcurb array is blank
        this.stored_breadCrumbs.push({
          [element.value]: temp,
        });
      }
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
      if (this.basics == "date" && this.aggregate == "day") {
        // reset page info, when basics is date && aggregate is day
        this.resetPageInfo();
      }
      // console.log(" handle ", this.pageInfo);
      if(element.basics) {
        let elementBasics = element.basics.toLowerCase() + 's';
        // queryObject.basics = element.basics;
        if(element.basics == 'region') {
          queryObject.basics = 'subregion';
        } else if(element.basics == 'subregion') {
          queryObject.basics = 'outlet';
        }
        if(queryObject.filters && !this.isEmptyObject(queryObject.filters)) {
          // queryObject.filters.forEach((el, elIndex) => {
          //   queryObject.filters[elIndex] = [];
          // });
          for(let prop in queryObject.filters) {
            queryObject.filters[prop] = [];
          }
        }
        if(elementBasics == 'outlets') {
          queryObject.filters[elementBasics] = [element.id];
        }
      }
      if(queryObject.basics != 'date') {
        this.getAllSalesForecastData(queryObject);
      }
      this.inputChanged(queryObject, this.pageInfo, element);
    },
    breadcrumbHandleButtonClick(element, selected_breadcrumb) {
      // console.log("element", element);
      this.resetPageInfo();

      if (this.isLocationPage) {
        this.loc_selected = [element[0]];
      }

      if (this.isCategoryPage) {
        this.cat_selected = [element[0]];
      }
      if (this.isCentralKitchenPage) {
        this.cat_selected = [element[0]];
      }
      // ******************set queryObject of current clickabled breadcurmb**********************************
      for (var i in this.stored_breadCrumbs) {
        for (var key in this.stored_breadCrumbs[i]) {
          if (key == selected_breadcrumb) {
            // *******************Removed next clickable breadCurmb************************************
            this.stored_breadCrumbs.splice(
              Number(i) + 1,
              this.stored_breadCrumbs.length - 1
            );
          }
        }
      }
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
      // this.basics = analyticsQueryObject.basics;
      const queryObject = element[2]; // extracting queryObject from breadcrumb array
      this.basicsInfo = element[1];

      if (this.aggregate == "day" && this.basics == "date") {
        // reset aggregate and num_period to week and num of weeks resp.
        this.period = queryObject.num_period + " week";
        this.start_date = queryObject.start_date;
      }
      let tempQueryObject = this.queryObject(this.basicsInfo);
      if(tempQueryObject.filters && !this.isEmptyObject(tempQueryObject.filters)) {
        for(let prop in tempQueryObject.filters) {
          tempQueryObject.filters[prop] = [];
        }
      }
      this.inputChanged(tempQueryObject, this.pageInfo);
    },
    breadcrumbClickableFn(selected_breadcrumb, element) {
      if (this.basics == "outlet") {
        // used in utils file
        this.$store.commit("AppForecastStore/OUTLET", element[0]);
      }
      this.breadcrumbHandleButtonClick(element, selected_breadcrumb);
    },
    showInitialData() {
      // set initial all variable for shown default render table data
      if (
        this.$route.name === "forecastCategory" ||
        this.$route.name === "forecastCentralKitchen"
      ) {
        this.setWeekIncludeStartDay();
      }
      // console.log("this.basicsInfo1", this.basicsInfo, this.$route.name);
      this.basicsInfo = {
        id: "",
        route: this.$route.name,
        basicsFrom: "",
        previousBasics: "",
        currentBasics:
          // this.$route.name == "forecastLocation" ? "region" : "category"
          this.$route.name != "forecastCategory" &&
          this.$route.name != "forecastCentralKitchen"
            ? "region"
            : "category",
      };
      // console.log("this.basicsInfo", this.basicsInfo);
      let tempQueryObject = this.queryObject(this.basicsInfo);
      if(tempQueryObject.filters && !this.isEmptyObject(tempQueryObject.filters)) {
        for(let prop in tempQueryObject.filters) {
          tempQueryObject.filters[prop] = [];
        }
      }
      this.inputChanged(tempQueryObject, this.pageInfo);
      this.stored_breadCrumbs = []; //clear all breadcurmbs
      EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
    },
    setWeekIncludeStartDay() {
      var date = moment().startOf("week").add("d", 1).format("YYYY-MM-DD");
      this.start_date = date;
      this.include_start_day = true;
    },
    generateSalesForecast() {
      // generate table data
      this.periodChange();
      // generate graph data
      this.getAllSalesForecastData();
    },
    getAllSalesForecastData(extraParams = undefined) {
      this.graphLoader = true;
      let params = {
        "start_date": moment(this.fromDate).format("YYYY-MM-DD"),
        "num_period": this.days,
        "include_start_day": true,
        "view": "amt",
        "aggregate": "day",
        "basics": "outlet",
        "include_dates": true,
        "filters": {
            "countries": [],
            "regions": [],
            "subregions": [],
            "outlets": [],
            "departments": [],
            "categories": [],
            "subcategories": [],
            "products": []
        },
        "extra_keys": this.$route.name == "forecastLocation" ? "trans" : "qty"
      }
      let tempParams = this.queryObject(this.basicsInfo);
      let outlets = [];
      if(typeof(this.loc_selected[0]) === 'object'){
        outlets = [this.loc_selected[0].id];
      } else {
        outlets = this.loc_selected.length ? this.loc_selected : [];
      }

      params.basics = tempParams.basics;
      params.filters.outlets = outlets;
      if(extraParams) {
        params.basics = extraParams.basics;
        params.filters.outlets = outlets;
      }
      // Updated filters and added outlets
      // params.filters.outlets = this.loc_selected.length ? this.loc_selected : [];
      // get sales forecast data
      forecastService.getAllForecast(params)
      .then(response => {
        let responseData = JSON.parse(JSON.stringify(response.data));
        this.forecastChartListData = responseData;
        EventBus.$emit("createForecastChartElement", responseData);
      }).catch(error => {
        console.error(error);
      }).finally(res => {
        this.graphLoader = false;
      });
    },
    periodChange() {
      if (this.start_date !== this.currentDate()) {
        // removed last breadCrumb, when start date is not current date..
        this.stored_breadCrumbs.splice(this.stored_breadCrumbs.length - 1, 1);
        EventBus.$emit("breadCrumbs", this.stored_breadCrumbs);
        // activate last Breadcrumb
        for (var i in this.stored_breadCrumbs) {
          for (var key in this.stored_breadCrumbs[i]) {
            EventBus.$emit("activeBreadCrumb", key);
          }
        }
      }
      // this.start_date = this.currentDate();

      if (
        this.$route.name == "forecastLocation" ||
        this.$route.name == "forecastCategory" ||
        this.$route.name == "forecastCentralKitchen"
      ) {
        if (this.period == "day") {
          EventBus.$emit("breadCrumbs", []);
        }
      }
      // this.$store.commit(
      // 	"AppForecastStore/NUM_PERIOD_STORE",
      // 	this.periodMapping[this.period]
      // );
      // this.$store.commit("AppForecastStore/AGGREGATE_STORE", this.getAggreate);
      // this.$store.commit("AppForecastStore/PERIOD_STORE", this.period);
      // this.$store.commit("AppForecastStore/BASICS_STORE", this.basicsStore);
      EventBus.$emit("selectedPeriod", this.period);

      if (
        this.period == "day" &&
        !this.isCategoryPage &&
        !this.isCentralKitchenPage
      ) {
        // this.loc_selected = [];
        this.basicsInfo.currentBasics = "outlet";
        // this.$store.commit("AppForecastStore/BASICS_STORE", "outlet");
        // this.$store.commit("AppForecastStore/NUM_PERIOD_STORE", 1);
        // this.$store.commit("AppForecastStore/AGGREGATE_STORE", "day");
      } else if (
        this.period == "day" &&
        (this.isCategoryPage || this.isCentralKitchenPage)
      ) {
        // when period selected is 1 day, then set currentBasics is "category" and  previousBasics is empty
        this.basicsInfo.currentBasics = "category";
        this.basicsInfo.previousBasics = "";
        this.aggregate = "day";
        this.basicsInfo.id = "";
        this.include_start_day = false;
      } else if (
        this.period != "day" &&
        (this.isCategoryPage || this.isCentralKitchenPage)
      ) {
        this.setWeekIncludeStartDay();
      }
      this.resetPageInfo();
      this.inputChanged(this.queryObject(this.basicsInfo), this.pageInfo);
    },
    checkPassDate(currentDate) {
      var UserDate = currentDate;
      var ToDate = new Date();

      if (new Date(UserDate).getTime() >= ToDate.getTime()) {
        return false;
      }
      return true;
    },
    handleforecastDetailQuery(element) {
      console.log('forecastQueryDetail', element);
      const queryDetailParams = [
        { date_offset: null, type: "forecast" },
        { date_offset: "week", type: "sale" },
        { date_offset: "year", type: "sale" },
      ];
      const queryDetailObject = {
        date: element.date, // selected date
        outlet: element.id,
        type: "sale",
        date_offset: "year",
      };
      const queryDetailObjectArray = [];
      for (let i = 0; i < 3; i++) {
        queryDetailObjectArray[i] = Object.assign(
          {},
          queryDetailObject,
          queryDetailParams[i]
        );
      }
      axios
        .all([
          ForecastService.forecastQueryDetail(queryDetailObjectArray[0]),
          ForecastService.forecastQueryDetail(queryDetailObjectArray[1]),
          ForecastService.forecastQueryDetail(queryDetailObjectArray[2]),
        ])
        .then(
          axios.spread(
            (date_offset_null, date_offset_week, date_offset_year) => {
              this.$set(
                this.queryDetailResponse,
                "date_offset_null",
                JSON.parse(date_offset_null.data)
              );
              this.$set(
                this.queryDetailResponse,
                "date_offset_week",
                JSON.parse(date_offset_week.data)
              );
              this.$set(
                this.queryDetailResponse,
                "date_offset_year",
                JSON.parse(date_offset_year.data)
              );
              this.$set(
                this.queryDetailResponse,
                "buttonClickedObject",
                element
              );
              this.approveDisable = this.checkPassDate(
                this.queryDetailResponse.buttonClickedObject.date
              );
              this.dialogVisible = true;
              this.componentKey += 1;
              // console.log("date_offset_null", date_offset_null);
              // console.log("date_offset_week", date_offset_week);
              // console.log("date_offset_year", date_offset_year);
            }
          )
        );
    },
    getOptionsSelected() {
      // console.log("getOptionsSelected");
      if (
        this.$route.name == "forecastLocation" ||
        this.$route.name == "forecastCategory" ||
        this.$route.name == "forecastCentralKitchen"
      ) {
        var idNameMap = this.getIdNameMap(this.locations);
        var names = this.filters.map((id) => {
          for (var i = 0; i < idNameMap.length; i++) {
            if (idNameMap[i].id == id) {
              return idNameMap[i].name;
            }
          }
        });
        return this.downloadCsv(names, this.period, this.forecastAnalytics);
      }
    },
    closeDialogBox() {
      console.log("indise event");
      this.dialogVisible = false;
    },
    resetPageInfo() {
      EventBus.$emit("resetPageInfoEvent");
      // console.log("resseting page info");
      this.pageInfo.pageSize = 10;
      this.pageInfo.currentPage = 1;
    },
    isSubregions(id) {
      // if there is a subregion for a region then this fn return true else false
      // console.log(id);
      function searchSubregionsField(arr) {
        arr.map((obj) => {
          if (obj.id == id) {
            if ("subregions" in obj) {
              return true;
            }
          }
          Object.keys(obj).map((key) => {
            if (Array.isArray(obj[key])) {
              searchSubregionsField(obj[key]);
            }
          });
        });
      }
      if (searchSubregionsField(this.locations)) {
        return true;
      }
      return false;
    },
    // unConsolidated() {
    // 	this.isConsolidated = false;
    // 	return this.fetchForecast(this.queryObject)
    // 		.then(tableData => {
    // 			var ids = tableData.map(obj => {
    // 				return Object.keys(obj)[0];
    // 			});
    // 			return { ids: ids, tableData: tableData };
    // 		})
    // 		.then(response => {
    // 			return ForecastService.mapIds({
    // 				basics: this.basics,
    // 				id_list: response.ids
    // 			})
    // 				.then(mappingOfIds => {
    // 					var mappedIds = JSON.parse(mappingOfIds.data);
    // 					return { tableData: response.tableData, mappedIds: mappedIds };
    // 				})
    // 				.catch(error => {
    // 					throw error;
    // 				});
    // 		})
    // 		.catch(error => {
    // 			console.log(error);
    // 		});
    // },
    // consolidated() {
    // 	this.isConsolidated = true;
    // 	return this.fetchForecast(this.queryObject).catch(error => {
    // 		console.log(error);
    // 	});
    // },
    // forecastQuery() {
    // 	this.$store.commit(
    // 		"AppForecastStore/NUM_PERIOD_STORE",
    // 		this.periodMapping[this.period]
    // 	);
    // 	this.$store.commit("AppForecastStore/AGGREGATE_STORE", this.getAggreate);
    // 	this.$store.commit("AppForecastStore/PERIOD_STORE", this.period);
    // 	axios.all([this.unConsolidated(), this.consolidated()]).then(
    // 		axios.spread((tableData, consolidated) => {
    // 			// console.log("spread", consolidated, tableData);
    // 			const final = this.postInputChanged(
    // 				tableData.tableData,
    // 				tableData.mappedIds,
    // 				consolidated
    // 			);
    // 			this.$store.commit("AppForecastStore/FORECAST_ANALYTICS", final);
    // 		})
    // 	);
    // },
    checkForSubBasics() {
      this.locations.map((obj) => {
        if (obj.id == btnClicked.id) {
          return obj;
        }
        Object.keys(obj).map((key) => {
          if (Array.isArray(obj[key])) {
            this.checkForSubBasics(obj[key]);
          }
        });
      });
      return null;
    },
    loadCentralKitchenDashboard(args) {
      CommonService.getOutlets(args)
        .then((response) => {
          if (response.status == 200) {
            var outlets = [];
            var outletResponse = JSON.parse(response.data);
            var queryForCentralKitchen = this.queryObject(this.basicsInfo);
            // collect outlets for called query api using central kitchen type
            for (var i in outletResponse) {
              outlets.push(outletResponse[i].id);
            }
            queryForCentralKitchen.filters.outlets = outlets;
            this.inputChanged(queryForCentralKitchen, this.pageInfo);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    disabledFromDate() {
      let time = new Date();
      return time.getTime() > Date.now() - 8.64e7;
    },
    disabledToDate() {
      var fromDate = new Date(this.fromDate);
      // console.log(time , fromDate);
      fromDate = fromDate.getTime();
      if (time.getTime() <= fromDate - 8.64e7) {
        return time.getTime() < fromDate - 8.64e7;
      } else {
        return time.getTime() > Date.now() - 8.64e7;
      }
    },
    getLocations(args) {
      CommonService.getLocations(args)
        .then((response) => {
          var locations = CommonUtils.insertIsSelectedKey(
            JSON.parse(response.data).results
          );
          this.updatedLocations = JSON.parse(response.data).results;
          locations.forEach((item, index) => {
            this.$set(this.locations, index, item);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./AppForecastTab.scss";
</style>
<style>
.AppForecast .el-dialog__body {
  padding: 0;
}
.AppForecast .el-dialog__headerbtn {
  top: 18px;
  right: 18px;
}
.AppForecast .el-dialog__header {
  padding: 0;
}
.AppForecast .el-icon-close:before {
  color: #fff;
}
.AppForecast .el-dialog {
  width: 85%;
  /* margin-top: 5vh !important; */
}
@media screen and (max-width: 992px) {
  .AppForecast .el-dialog {
    width: 95%;
  }
}
</style>
